<i *ngIf="!hidden" class="fad fa-circle text-{{ color }} fa-xs"></i>
